import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'
import {
  resetChannelChanges,
  setChannelList,
  setChannelTableFilters,
  setCountriesList,
} from 'Slices/Settings/ChannelSlice'

const getChannels = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  return createRequest('/api/channel/active/?config=' + state.present.article.serverConfig, 'GET', undefined, token)
    .then(response => response.json())
    .then(data => {
      dispatch(setChannelList(data))
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed on retrieve channels getChannels')
    })
}

const updateChannels = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    (state.present.channel.channelDataChanges && state.present.channel.channelDataChanges.length === 0) ||
    !token
  ) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  //send channel that had changes
  const channelsToSave = state.present.channel.channelList.filter(
    x => state.present.channel.channelDataChanges.indexOf(x.name) !== -1,
  )

  return createRequest('/api/channel/?config=' + state.present.article.serverConfig, 'POST', channelsToSave, token)
    .then(response => {
      if (response.ok) {
        dispatch(getChannels())
        dispatch(resetChannelChanges())
      }
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed on update channel updateChannels')
    })
}

const getChannelFilters = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  const isSuperCategoryEnabled = state.present.configuration.isSuperCategoryEnabled
  const url = `/api/channel/filters?config=${state.present.article.serverConfig}&isSuperCategoryEnabled=${isSuperCategoryEnabled}`
  return createRequest(url, 'GET', undefined, token)
    .then(response => response.json())
    .then(data => {
      if (data) {
        dispatch(setChannelTableFilters(data))
      }
    })
}

const getCountries = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  return createRequest('/api/country?config=' + state.present.article.serverConfig, 'GET', undefined, token)
    .then(response => response.json())
    .then(data => {
      dispatch(setCountriesList(data))
    })
    .catch(err => {
      handleErrorCatchLog(err, 'failed on retrieve countries getCountries')
    })
}

export { getCountries, getChannels, updateChannels, getChannelFilters }
